<template>
  <div class="flex" style="display: flex; /* width: 500px; */">
    <menu-item
      v-for="(sport, i) in sports"
      :key="sport.id"
      :active="isActive(sport.id, i)"
      :sport="sport"
      @click="$router.push('/live/sport/' + sport.id)">
      <sport-icon-liga-white :name="sport.alias" />
      <span class="count-events">{{ sport.events.length }}</span>
      <span>{{ sport.name }}</span>
    </menu-item>
  </div>
</template>

<script>
import MScrollbar from '@/components/MScrollbar'
import MenuItem from '@/components/live/overview/MenuItem'
import { mapState } from 'vuex'

export default {
  components: { MScrollbar, MenuItem },
  computed: {
    ...mapState({
      sports: state => state.live.menu
    })
  },
  data () {
    return {
      updateInterval: null
    }
  },
  mounted () {
    this.dispatchGetting()
    this.updateInterval = setInterval(this.dispatchGetting.bind(this), 1000)
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.dispatchGetting()
    }
  },
  methods: {
    dispatchGetting () {
      this.$store.dispatch('live/GET_MENU_SPORTS')
    },
    isActive (sport, i) {
      if (this.$route.params.sport) {
        return sport === parseInt(this.$route.params.sport)
      } else {
        return i === 0
      }
    }
  }
}
</script>

<style scoped>
.count-events { z-index: 1;
    margin-top: -30px;
    position: absolute;
    margin-left: 36px;
    font-weight: 700;
    font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/components/live/overview/Menu.vue